import type { AxiosInstance } from 'axios';
export interface FileReference {
  id: string;
  fileName: string;
  contentType: string;
  size: number;
  url: string;
  createdAt: string;
  workflow?: string;
}

export function createFileService(client: AxiosInstance) {
  return {
    upload: async (file: File, workflow?: string): Promise<FileReference> => {
      const formData = new FormData();
      formData.append('file', file);
      if (workflow) {
        formData.append('workflow', workflow);
      }
      const { data } = await client.post<FileReference>('/v1/files', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return data;
    },

    getFileUrl: (fileId: string): string => {
      const base = client.defaults.baseURL ?? '';
      return `${base}/v1/files/${fileId}`;
    },

    download: (fileId: string) =>
      client.get<Blob>(`/v1/files/${fileId}`, { responseType: 'blob' }),

    delete: (fileId: string) =>
      client.delete(`/v1/files/${fileId}`),

    /**
     * Server-side convert a DOCX file to PDF (used to show uploaded-DOCX previews
     * in react-pdf without shipping a docx renderer client-side). Matches
     * document-signing's `POST /v1/files/{id}/convert-to-pdf` route.
     */
    convertToPdf: (fileId: string) =>
      client.post<Blob>(`/v1/files/${fileId}/convert-to-pdf`, null, { responseType: 'blob' }),

    /**
     * Stamp placeholder values into a DOCX file and return the resulting PDF.
     * Used by the envelope wizard when entering Place Fields so the field
     * overlay is drawn on top of the filled PDF, not the raw template.
     */
    generatePdf: (fileId: string, placeholderValues: Record<string, string>) =>
      client.post<Blob>(`/v1/files/${fileId}/generate-pdf`, placeholderValues, { responseType: 'blob' }),
  };
}
